import { packets } from "./packets";

export const packetHandler = new Map(Object.entries(packets));
